module.exports = __webpack_public_path__ + "img/titleAtive1.72ac365.png";